import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-tail",
  "use": "icon-arrow-right-tail-usage",
  "viewBox": "0 0 17 8",
  "content": "<symbol viewBox=\"0 0 17 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right-tail\">\n<path d=\"M16.3536 4.03568C16.5488 3.84042 16.5488 3.52384 16.3536 3.32858L13.1716 0.146595C12.9763 -0.0486672 12.6597 -0.0486672 12.4645 0.146595C12.2692 0.341857 12.2692 0.65844 12.4645 0.853702L15.2929 3.68213L12.4645 6.51056C12.2692 6.70582 12.2692 7.0224 12.4645 7.21766C12.6597 7.41293 12.9763 7.41293 13.1716 7.21766L16.3536 4.03568ZM0 3.68213V4.18213H16V3.68213V3.18213H0V3.68213Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow-right-tail.svg
// module id = uSH4
// module chunks = 258